/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as searchReducer } from "./searchSlice";
export {
  clearRecentSearchesLocal,
  deleteSearchHistoryThunk,
  fetchSearchHistoryThunk,
  loadMoreSmartSearchCarousels,
  navigateHistoryDown,
  navigateHistoryUp,
  navigateResultsDown,
  navigateResultsUp,
  pushRecentSearch,
  resetSearchScreenState,
  runSmartSearch,
  saveSearchHistoryThunk,
  selectRecentSearches,
  selectSearchCarousels,
  selectSearchErrorMessage,
  selectSearchFocusedCarouselIndex,
  selectSearchFocusedField,
  selectSearchFocusedHistoryIndex,
  selectSearchFocusedTileIndices,
  selectSearchHistoryStatus,
  selectSearchIsLoadingMore,
  selectSearchPageCursor,
  selectSearchPendingQuery,
  selectSearchQuery,
  selectSearchResolvedCount,
  selectSearchStatus,
  setFocusedCarouselIndex,
  setFocusedField,
  setFocusedHistoryIndex,
  setFocusedTileIndex,
  setQuery,
  trackSearchContentHighlighted,
  trackSearchContentSelected
} from "./searchSlice";
export type {
  SearchFocusedField,
  SearchHistoryStatus,
  SearchState,
  SearchStatus
} from "./search.types";
